import request from '@/utils/request'
// 获取当前用户详情
export function getPresentUserInfo(query) {
  return request({
    url: '/app-api/service/user/getPresentUserInfo/v1_0_0',
    method: 'get',
    params: query
  })
}
// 获取用户系统消息列表
export function getAppSysMsgList(query) {
  return request({
    url: '/app-api/service/user/getAppSysMsgList/v1_0_0',
    method: 'get',
    params: query
  })
}
// 获取常见问题列表
export function getFaqList(query) {
  return request({
    url: '/app-api/service/common/getFaqList/v1_0_0',
    method: 'get',
    params: query
  })
}
// 提交问题反馈
export function submitFeedback(data) {
  return request({
    url: '/app-api/service/common/submitFeedback/v1_0_0',
    method: 'post',
    data: data
  })
}
// 修改密码
export function updatePassWord(data) {
  return request({
    url: '/app-api/service/user/updatePassWord/v1_0_0',
    method: 'post',
    data: data
  })
}
// 获取静态页面内容
export function getHtmlContentByType(query) {
  return request({
    url: '/app-api/service/common/getHtmlContentByType/v1_0_0',
    method: 'get',
    params: query
  })
}
// 获取用户虚拟币账单列表
export function getBalanceBillList(query) {
  return request({
    url: '/app-api/service/user/getBalanceBillList/v1_0_0',
    method: 'get',
    params: query
  })
}
// 修改用户资料
export function updUserInfo(data) {
  return request({
    url: '/app-api/service/user/updUserInfo/v1_0_0',
    method: 'post',
    data: data
  })
}
// 获取未读消息数量
export function getMsgUnreadCount(query) {
  return request({
    url: '/app-api/service/user/getMsgUnreadCount/v1_0_0',
    method: 'get',
    params: query
  })
}
// 获取app下载配置
export function getAppDownloadConfig(query) {
  return request({
    url: '/app-api/service/common/getAppDownloadConfig/v1_0_0',
    method: 'get',
    params: query
  })
}

// 获取流水记录列表
export function getFlowRecordList(query) {
  return request({
    url: '/app-api/service/user/getFlowRecordList/v1_0_0',
    method: 'get',
    params: query
  })
}


// WEBPACK FOOTER //
// ./src/api/user.js